import { render, staticRenderFns } from "./alertAccountsPayable.vue?vue&type=template&id=0e633f05"
import script from "./alertAccountsPayable.vue?vue&type=script&lang=js"
export * from "./alertAccountsPayable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports